// Realtime notifications for the navbar bell (gym owners/coaches).

import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  doc,
  updateDoc,
  writeBatch,
} from 'firebase/firestore';
import { db } from 'config/firebase';
import { COLLECTIONS } from 'constants/collections';

// Subscribe to a user's latest 20 notifications (newest first). Returns the
// unsubscribe fn — callers MUST call it on cleanup (Standards.md §3.2).
export const subscribeToNotifications = (uid, onChange) => {
  const q = query(
    collection(db, COLLECTIONS.NOTIFICATIONS),
    where('recipientId', '==', uid),
    orderBy('createdAt', 'desc'),
    limit(20)
  );
  return onSnapshot(q, (snap) => onChange(snap.docs.map((d) => ({ ...d.data(), id: d.id }))));
};

export const markNotificationRead = (id) =>
  updateDoc(doc(db, COLLECTIONS.NOTIFICATIONS, id), { read: true });

export const markNotificationsRead = async (notifications) => {
  const batch = writeBatch(db);
  notifications
    .filter((n) => !n.read)
    .forEach((n) => batch.update(doc(db, COLLECTIONS.NOTIFICATIONS, n.id), { read: true }));
  await batch.commit();
};
